var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 4 4 C 2.976 4 2.1404375 4.772625 2.0234375 5.765625 L 12 12 L 21.976562 5.765625 C 21.859563 4.772625 21.024 4 20 4 L 4 4 z M 2 7.7519531 L 2 18 C 2 19.105 2.895 20 4 20 L 20 20 C 21.105 20 22 19.105 22 18 L 22 7.7519531 L 12.529297 13.669922 C 12.205297 13.871922 11.794703 13.871922 11.470703 13.669922 L 2 7.7519531 z"}));
}

Mail.defaultProps = {"x":"0px","y":"0px","width":"48","height":"48","viewBox":"0 0 24 24"};

module.exports = Mail;

Mail.default = Mail;
